import { ActionCreatorWithPayload } from "@reduxjs/toolkit";
import { startPolling } from "./slices";
import { Duration } from "./types";

/**
 * The way screens start polling. Prefer this over dispatching `startPolling`
 * directly: its payload types `params` as `Record<string, unknown>`, so a
 * misspelled or missing param compiles fine and only breaks at runtime.
 *
 * The store still only holds serializable data (`actionType` string + plain
 * `params`), while `params` stays type-checked against the polled action
 * creator's payload.
 *
 * Usage:
 *   dispatch(createPolling({
 *     id: `${POLL_ID_PREFIX}/${POLL_IDS.foo}`,
 *     actionCreator: fooActions.getFooRequest,
 *     params: { regionId, projectId }
 *   }));
 */
export const createPolling = <P extends Record<string, unknown>>(config: {
  id: string;
  actionCreator: ActionCreatorWithPayload<P>;
  params: P;
  interval?: Duration;
}) =>
  startPolling({
    id: config.id,
    actionType: config.actionCreator.type,
    params: config.params,
    interval: config.interval
  });
